import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../../assets/css/Profile.css";
import SideBar from "../../Components/SideBar/SideBar";
import { Link, useNavigate } from "react-router-dom";
import TopBar from "../../Components/SideBar/TopBar";
import { GetCustomerOrders, GetMyOrders } from "../../network/Network";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import Skeleton from "react-loading-skeleton";
import moment from "moment";

function MyBooking() {
  const Token = useSelector((state) => state.AuthReducer.token);
  const [pageCount, setPageCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [newFile, setNewFile] = useState("");
  const [orderAll, setOrderAll] = useState(null);
  const [fileupload, setFileupload] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);
  const [editState, setEditState] = useState(false);
  const [passLoading, setPassLoading] = useState(false);

  const [firstName, setFirstName] = useState("John");
  const [lastName, setLastName] = useState("Doe");
  const [phone, setPhone] = useState("0123432432");
  const [editLoading, setEditLoading] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [passwordChange, setPasswordChange] = useState(false);
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

  const handlePageClick = async (data) => {
    setCurrentPage(data?.selected + 1);
  };

  useEffect(() => {
    GetCustomerOrders(currentPage, Token);
  }, [currentPage]);

  const handleImageUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setNewFile(file);
      setFileupload(reader.result);
    };
    reader.readAsDataURL(file);
    setUploadLoading(true);
  };

  useEffect(() => {
    setLoading(true);
    GetCustomerOrders(currentPage, Token)
      .then((res) => {
        setOrderAll(res?.data?.response?.data?.data);
        const total = res?.data?.response?.data.total;
        const limit = res?.data?.response?.data.per_page;
        setPageCount(Math.ceil(total / limit));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [currentPage]);

  return (
    <>
      <Header />

      {/* <!-- Universal Banner Sec End Here --> */}
      <section className="profile">
        <div className="container">
          <div className="row profile-row">
            <SideBar
              uploadLoading={uploadLoading}
              fileupload={fileupload}
              handleImageUpload={handleImageUpload}
            />
            <div className="col-lg-9">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <TopBar />

                  <div className="row">
                    <div className="col-lg-12 ">
                      <h3 className="form-heading heading-top-cont">
                        My Bookings
                      </h3>
                      {loading ? (
                        <Skeleton count={8} />
                      ) : (
                        <>
                          <div className="order-table-wrapper table-responsive">
                            <table>
                              <tbody>
                                <tr className="row1">
                                  <th className="order-no">Booking ID</th>
                                  <th className="order-date">Booking Type</th>
                                  <th className="order-status">Date & Time</th>
                                  <th className="order-status">
                                    Payment Status
                                  </th>
                                  <th className="order-pay">Total</th>
                                  <th className="details">Details</th>
                                </tr>
                                {orderAll?.map((item, index) => {
                                  return (
                                    <>
                                      <tr className="row2" key={index}>
                                        <td className="number">#{item?.id}</td>
                                        <td className="date">
                                          {/* {item?.membership} */}
                                          {item?.membership?.type}
                                        </td>
                                        <td className="date">
                                          {/* {item?.booking_date} */}
                                          {/* {item?.booking_date}{" "}{item?.booking_time} */}
                                          {moment(
                                            `${item?.booking_date}  ${item?.booking_time}`
                                          ).format("MMMM Do YYYY, h:mm a")}
                                        </td>
                                        <td className="paid confirm">
                                          {item?.membership?.status == 1
                                            ? "Paid"
                                            : "Pending"}
                                          {/* <i
																				className="fa fa-check-circle"
																				aria-hidden="true"
																			></i> */}
                                        </td>
                                        <td className="total-price">
                                          $ {item?.price}
                                        </td>

                                        <td className="order-details">
                                          <a
                                            className="order-details-btn"
                                            onClick={() =>
                                              navigate("/booking-details", {
                                                state: item,
                                              })
                                            }
                                          >
                                            view Details
                                          </a>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}

                      {orderAll?.length > 0 ? (
                        <div className="pagination-container mt-5">
                          <ReactPaginate
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel={"..."}
                            pageCount={pageCount}
                            // marginPagesDisplayed={2}
                            // pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={
                              "pagination justify-content-center"
                            }
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                          {/* <p className="Total-Product">12 PRODUCTS 1 - 12</p> */}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default MyBooking;
